export const INTEGRATION_DEBUG_STORAGE_KEY = "loadAgent.integrationDebug.v1";
export type IntegrationRawExchange = {
  requestRaw: string;
  responseRaw: string;
  requestMeta?: string;
  requestBodyPrepared?: string;
};
export type IntegrationDebugPayload = {
  tms?: IntegrationRawExchange[];
  tmsProviderName?: string;
  greenscreens?: IntegrationRawExchange;
  sonar?: IntegrationRawExchange[];
};

function normalizeIntegrationDebugPayload(raw: unknown): IntegrationDebugPayload | null {
  if (raw == null || typeof raw !== "object") return null;
  const o = raw as Record<string, unknown>;
  const tmsRaw = o.tms;
  const normalizedTms = Array.isArray(tmsRaw)
    ? (tmsRaw as IntegrationRawExchange[])
    : tmsRaw && typeof tmsRaw === "object"
      ? [tmsRaw as IntegrationRawExchange]
      : undefined;

  return {
    ...(normalizedTms?.length ? { tms: normalizedTms } : {}),
    ...(typeof o.tmsProviderName === "string" ? { tmsProviderName: o.tmsProviderName } : {}),
    ...(o.greenscreens && typeof o.greenscreens === "object"
      ? { greenscreens: o.greenscreens as IntegrationRawExchange }
      : {}),
    ...(Array.isArray(o.sonar) ? { sonar: o.sonar as IntegrationRawExchange[] } : {}),
  };
}

export function persistIntegrationDebugFromResponse(body: unknown): void {
  if (typeof window === "undefined") return;
  if (body == null || typeof body !== "object") return;
  const integrationDebug = (body as Record<string, unknown>).integrationDebug;
  const normalized = normalizeIntegrationDebugPayload(integrationDebug);

  if (!normalized) return;
  try {
    window.localStorage.setItem(INTEGRATION_DEBUG_STORAGE_KEY, JSON.stringify(normalized));
  } catch (error) {
    void error;
  }
}
export const persistIntegrationDebugFromQuoteResponse = persistIntegrationDebugFromResponse;
export function readIntegrationDebugFromStorage(): IntegrationDebugPayload | null {
  if (typeof window === "undefined") return null;
  try {
    const raw = window.localStorage.getItem(INTEGRATION_DEBUG_STORAGE_KEY);

    if (!raw?.trim()) return null;
    const parsed = JSON.parse(raw) as IntegrationDebugPayload;

    if (parsed == null || typeof parsed !== "object") return null;
    return parsed;
  } catch {
    return null;
  }
}
